import React, {useState} from "react";

export function ABAccordion({title, description, body}) {
    const [show, setShow] = useState(false);

    function handleOnClick() {
        setShow(!show);
    }

    return <>
        <div className={`text-start d-flex align-items-center justify-content-between my-2 px-1 rounded ${show ? "bg-primary-subtle" : "hover-bg-secondary-subtle"}`}
             onClick={handleOnClick}>
            <div className="d-flex flex-column my-1">
                <div className="text-capitalize fw-semibold fs-5">{title}</div>
                {description && <div>{description}</div>}
            </div>
            <div><i className={show ? "bi-chevron-up" :"bi bi-chevron-down"}/></div>
        </div>
        {show && <div className="p-1">{body}</div>}
    </>
}
